import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const svTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Namn (gemener, inga specialtecken)',
    add: 'Lägg till',
    allowedFileTypes: 'Tillåtna filtyper',
    allowedFileTypesDescription:
      'Begränsa tillåtna filtyper (t.ex. bild/*, program/pdf). Lämna tomt för att tillåta alla typer.',
    allowMultipleFiles: 'Tillåt flera filer',
    amountInCents: 'Belopp i cent',
    basePrice: 'Baspris',
    bcc: 'BCC',
    brand: 'Varumärke',
    cc: 'CC',
    checkboxPlural: 'Kryssruta Fält',
    checkboxSingular: 'Kryssruta',
    checkedByDefault: 'Markerad som standard',
    chooseConfirmationType:
      'Välj om du vill visa ett meddelande på sidan eller omdirigera till en annan sida efter att de har skickat formuläret.',
    condition: 'Skick',
    confirmationMessage: 'Bekräftelsemeddelande',
    confirmationType: 'Bekräftelsetyp',
    countryPlural: 'Country Fields',
    countrySingular: 'Land',
    creditCard: 'Kreditkort',
    customURL: 'Anpassad webbadress',
    datePlural: 'Datumfält',
    dateSingular: 'Datum',
    defaultValue: 'Standardvärde',
    divide: 'Dela',
    documentToLinkTo: 'Dokument att länka till',
    doesNotEqual: 'Är inte lika',
    emailFrom: 'E-post från',
    emailPlural: 'E-postfält',
    emailsDescription:
      'Skicka anpassade e-postmeddelanden när formuläret skickas. Använd kommaseparerade listor för att skicka samma e-postmeddelande till flera mottagare. Om du vill referera till ett värde från det här formuläret, linda fältets namn med dubbla parenteser, dvs {{firstName}}. Du kan använda ett jokertecken {{*}} för att mata ut all data och {{*:table}} för att formatera den som en HTML-tabell i e-postmeddelandet.',
    emailSingular: 'E-post',
    emailTo: 'E-posta till',
    equals: 'Lika',
    field: 'Fält',
    fields: 'Fält',
    fieldWidth: 'Fältbredd (procent)',
    hasAnyValue: 'Har något värde',
    internalLink: 'Intern länk',
    label: 'Etikett',
    maxFileSize: 'Max filstorlek (byte)',
    maxFileSizeDescription: 'Maximal filstorlek i byte. Lämna tomt utan gräns.',
    message: 'Meddelande',
    messageDescription: 'Ange meddelandet som ska skickas i detta e-postmeddelande.',
    messagePlural: 'Meddelandeblock',
    messageSingular: 'Meddelande',
    mimeType: 'MIME-typ',
    mimeTypePlural: 'MIME-typer',
    mimeTypeSingular: 'MIME-typ',
    multiply: 'Multiplicera',
    numberPlural: 'Nummerfält',
    numberSingular: 'Nummer',
    optionPlural: 'Alternativ',
    optionSingular: 'Alternativ',
    paymentFieldPlural: 'Betalningsfält',
    paymentFieldSingular: 'Betalning',
    paymentProcessor: 'Betalningsbehandlare',
    paymentStatus: 'Status',
    placeholder: 'Platshållare',
    priceConditions: 'Prisvillkor',
    priceConditionsPlural: 'Prisvillkor',
    priceConditionsSingular: 'Pris skick',
    radioOptions: 'Alternativ för radioattribut',
    radioPlural: 'Radiofält',
    radioSingular: 'Radio',
    redirect: 'Omdirigera',
    replyTo: 'Svara till',
    required: 'Obligatoriskt',
    selectOptions: 'Välj Alternativ',
    selectPlural: 'Välj Fält',
    selectSingular: 'Välj',
    statePlural: 'State Fields',
    stateSingular: 'staten',
    staticValue: 'Statiskt värde',
    subject: 'Ämne',
    submitButton: 'Skicka knappetikett',
    subtract: 'Subtrahera',
    textareaPlural: 'Textområde Fält',
    textareaSingular: 'Textområde',
    textPlural: 'Textfält',
    textSingular: 'Text',
    title: 'Titel',
    token: 'token',
    uploadCollection: 'Ladda upp samling',
    uploadCollectionDescription: 'Välj vilken uppladdningssamling du vill lagra filer i',
    uploadFieldPlural: 'Ladda upp fält',
    uploadFieldSingular: 'Ladda upp',
    urlToRedirectTo: 'URL att omdirigera till',
    value: 'Värde',
    valueOfField: 'Fältets värde',
    valueType: 'Värdetyp',
  },
}

export const sv: PluginLanguage = {
  dateFNSKey: 'sv',
  translations: svTranslations,
}
